import './i18n'

import { useMemo } from 'react'

import { detectAuthMode } from './auth-mode'
import ApolloProvider from './contexts/ApolloProvider'
import Routes from './routes/routes'
import OperatorShell from './shells/OperatorShell'

// CurrentUser/CurrentAccount providers live inside AuthGuard (not here) so the
// public auth pages (/login, /account-select) can render without a session.
// Auth mode is intentionally NOT reactive — switching modes reloads the page.
const App = () => {
  const mode = useMemo(() => detectAuthMode(), [])
  if (mode === 'operator') return <OperatorShell />

  return (
    <ApolloProvider>
      <Routes />
    </ApolloProvider>
  )
}

export default App
